import "mdn-polyfills/Array.prototype.find";
import "mdn-polyfills/Array.prototype.findIndex";
import "mdn-polyfills/Array.prototype.forEach";
import "mdn-polyfills/Array.prototype.includes";
import "mdn-polyfills/String.prototype.padStart";
import "url-polyfill";
// tslint:disable-next-line:ordered-imports
import "./styles/index.css";
// tslint:disable-next-line:ordered-imports
import * as Sentry from "@sentry/react";
import { Elements } from "@stripe/react-stripe-js";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import initializePostHog from "./helpers/Posthog";
import initializeSentry from "./helpers/Sentry";
import { initializeStripe } from "./helpers/Stripe";
import SignalRProvider from "./providers/SignalRProvider";
import { store } from "./store";

// Initialize Sentry first to catch any errors that occur during app setup
initializeSentry();

initializePostHog();

// As of 2024-06-11 we are having trouble with clients accessing the site over HTTP. Despite:
// 1. Setting Azure Web App, Function App, and Front Door to redirect HTTP to HTTPS
// 2. Using `app.UseHttpsRedirection()` in `Startup.cs`
// 3. Enforcing HTTPS in the HTTPProvider
// This is another redundant attempt to force HTTPS, and can be removed if the other methods
// are found to be working reliably.
if (window.location.protocol === "http:") {
    Sentry.captureMessage("App accessed via HTTP. Redirecting to HTTPS...");
    window.location.replace(window.location.href.replace("http:", "https:"));
} else {
    // Create + start signalR hub connections
    SignalRProvider.BuildConnections(store.dispatch, store.getState);

    /** Begin initializing Stripe. Note, that consumers should assume it's loading until this resolves. */
    const stripePromise = initializeStripe();

    // main render
    ReactDOM.render(
        <Provider store={store}>
            <Elements stripe={stripePromise}>
                <Router>
                    <App />
                </Router>
            </Elements>
        </Provider>,
        document.getElementById("root")
    );
}
